import React, { useEffect, useState } from 'react'

import {
    CircularProgress,
    Dialog,
    DialogContent,
    DialogTitle,
    Grid,
    TextField,
    Typography,
} from '@material-ui/core'

import { useSelector } from 'react-redux'
import { selectUsuarioSeleccionado } from '../../../redux/reducer/loginReducer'
import { grupos_alumnos_pagos, grupos_alumnos_pagos_update_importe } from '../../../services/alumnos'

const DialogModalConfigPagoGrupo = ({ openModal, setOpenModal }) => {
    const usuarioSeleccionado = useSelector(state => selectUsuarioSeleccionado(state))

    const [grupos, setGrupos] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (!openModal) return

        setLoading(true)
        grupos_alumnos_pagos({ usuario_id: usuarioSeleccionado.id }).then(response => {
            setGrupos(response?.grupos ?? [])
            setLoading(false)
        })
    }, [openModal, usuarioSeleccionado.id])

    const handleChangeImporte = (id, valor) => {
        setGrupos(prev =>
            prev.map(g => g.id === id ? { ...g, importe_pago_tutor: valor } : g)
        )
    }

    const handleBlurImporte = (grupo) => {
        grupos_alumnos_pagos_update_importe({
            usuario_id: usuarioSeleccionado.id,
            grupo_id: grupo.id,
            importe: grupo.importe_pago_tutor,
        })
    }

    return (
        <Dialog
            open={openModal}
            onClose={() => setOpenModal(false)}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>Configurar pago por grupo</DialogTitle>
            <DialogContent style={{ minHeight: '200px' }}>
                {loading ? (
                    <Grid container justifyContent="center" style={{ padding: 40 }}>
                        <CircularProgress />
                    </Grid>
                ) : (
                    <Grid container spacing={2} style={{ paddingTop: 8, paddingBottom: 16 }}>

                        <Grid item xs={12}>
                            <Grid container spacing={1} style={{ paddingBottom: 4 }}>
                                <Grid item xs={7}>
                                    <Typography variant="subtitle2" color="textSecondary">
                                        Grupo
                                    </Typography>
                                </Grid>
                                <Grid item xs={5}>
                                    <Typography variant="subtitle2" color="textSecondary">
                                        Importe pago tutor (€)
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        {grupos.length === 0 && (
                            <Grid item xs={12}>
                                <Typography color="textSecondary">No hay grupos disponibles.</Typography>
                            </Grid>
                        )}

                        {grupos.map(grupo => (
                            <Grid item xs={12} key={grupo.id}>
                                <Grid container spacing={2} alignItems="center">
                                    <Grid item xs={7}>
                                        <Typography variant="body2">
                                            {grupo.descripcion}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={5}>
                                        <TextField
                                            type="number"
                                            value={grupo.importe_pago_tutor ?? ''}
                                            onChange={e => handleChangeImporte(grupo.id, e.target.value)}
                                            onBlur={() => handleBlurImporte(grupo)}
                                            variant="outlined"
                                            size="small"
                                            fullWidth
                                            inputProps={{ min: 0, step: '0.01' }}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        ))}

                    </Grid>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default DialogModalConfigPagoGrupo
